/** CircleResultCard — the /circle command's "Your inner circle" card. */
import { useEffect, useState } from 'react';
import { apiFetch } from '@/lib/apiClient';
import { useSession } from '@/features/auth/hooks/useSession';
import { getActiveWorkspaceId } from '@/lib/api/workspace-context';
import { CircleReport } from '../CircleReport';
import type { CircleData } from '../CircleReport';

interface DiscoveryStatusSlim {
  jobs?: { sent?: { circle?: CircleData } };
}

export function CircleResultCard({ initialData }: { initialData?: CircleData | null } = {}) {
  const [circle, setCircle] = useState<CircleData | null | undefined>(
    initialData !== undefined ? initialData : undefined,
  );
  const { token } = useSession();

  useEffect(() => {
    if (initialData !== undefined) return; // already seeded
    if (!token) return;
    let alive = true;
    (async () => {
      try {
        const wsId = getActiveWorkspaceId();
        const data = await apiFetch<DiscoveryStatusSlim>(
          `/workspaces/${wsId}/onboarding/discovery-status`,
          { authToken: token },
        );
        if (alive) setCircle(data?.jobs?.sent?.circle ?? null);
      } catch {
        if (alive) setCircle(null);
      }
    })();
    return () => { alive = false; };
  }, [token, initialData]);

  if (circle === undefined) return null;
  if (!circle || circle.closest.length === 0) {
    return <p>No inner-circle data yet — connect your email and let a sync finish.</p>;
  }
  return <CircleReport circle={circle} />;
}
